module.exports = __webpack_public_path__ + "img/img-grandstands-top.6845994d.jpg";